// this is an autogenerated file from DesignSystem/CommsThread/Content/EventsTimeline/Content/Event/Types/Sms/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_CommsThread_Content_EventsTimeline_Content_Event_Types_Sms($id: uuid!) {
  comms_events_sms_by_pk(id: $id) {
    id
    message
    is_inbound
    twilio_message_status
    created_at
    tags
    vaxiom_person_outbound {
      id
      person {
        id
        first_name
        last_name
      }
    }
    mobile_number_inbound {
      id
    }
    mobile_number_outbound {
      id
      name
      number
    }
  }
}

`